import Vue from 'vue'
import {
  extend,
  localize,
  ValidationObserver,
  ValidationProvider
} from 'vee-validate'

import * as Rules from 'vee-validate/dist/rules'
import id from 'vee-validate/dist/locale/id.json'

// Register komponen global
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

// Daftarkan semua rule bawaan dengan pesan default-nya
for (const rule in Rules) {
  if (Object.prototype.hasOwnProperty.call(Rules, rule)) {
    extend(rule, {
      ...Rules[rule],
      message: id.messages[rule] || 'Format tidak valid.'
    })
  }
}

// Custom rule untuk validasi password kompleks
extend('strongPassword', {
  validate: value =>
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/.test(value),
  message: 'Kata sandi harus mengandung huruf Kapital, angka, dan simbol.'
})

extend('no_hp', {
  validate: value => /^628[1-9]\d{7,10}$/.test(value),
  message: 'Nomor HP harus dimulai dengan 628 dan diikuti 10–13 digit angka.'
})

// Lokalize bahasa Indonesia dan custom pesan per field
localize('id', {
  messages: {
    ...id.messages,
    confirmed: 'Konfirmasi Kata Sandi tidak cocok.'
  },
  names: {
    nama: 'Nama',
    email: 'Email',
    no_hp: 'Nomor HP',
    password: 'Kata Sandi'
  },
  fields: {
    nama: {
      required: 'Nama wajib diisi.',
      regex: 'Nama hanya boleh berisi huruf dan spasi.'
    },
    email: {
      required: 'Email wajib diisi.',
      email: 'Format email tidak valid.'
    },
    no_hp: {
      required: 'Nomor HP wajib diisi.',
      no_hp: 'Nomor HP harus dimulai dengan 628 dan diikuti 10–13 digit angka.'
    },
    password: {
      required: 'Kata Sandi wajib diisi.',
      min: 'Kata Sandi minimal 8 karakter.',
      max: 'Kata Sandi maksimal 50 karakter.',
      strongPassword: 'Kata sandi harus mengandung huruf Kapital, angka, dan simbol.'
    }
  }
})

// Atur lokal default ke bahasa Indonesia
localize('id')
